export default __webpack_public_path__ + "static/cafod-ac92aa515cf19247d3b8bcdbfce5489b.png";